import type { RouteObject } from 'react-router';

export const routes: RouteObject[] = [
  {
    path: 'lectures',
    lazy: async () => ({ Component: (await import('./LecturesPage')).LecturesPage }),
  },
];
